import { render, staticRenderFns } from "./MonthPlan.vue?vue&type=template&id=048cc07b"
import script from "./MonthPlan.vue?vue&type=script&lang=ts"
export * from "./MonthPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports